import React, { useRef, useState } from 'react'

const normalizeSkill = (value) => value.trim().replace(/\s+/g, ' ')

const SkillsTagInput = ({ skills, onChange, disabled }) => {
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef(null)

  const addSkill = (raw) => {
    const skill = normalizeSkill(raw)
    if (!skill) return
    const exists = skills.some((s) => s.toLowerCase() === skill.toLowerCase())
    if (exists) return
    onChange([...skills, skill])
    setInputValue('')
  }

  const removeSkill = (index) => {
    onChange(skills.filter((_, i) => i !== index))
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      addSkill(inputValue)
    } else if (e.key === 'Backspace' && !inputValue && skills.length > 0) {
      onChange(skills.slice(0, -1))
    }
  }

  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text')
    if (!text.includes(',')) return
    e.preventDefault()
    const pasted = text
      .split(',')
      .map(normalizeSkill)
      .filter(Boolean)
    const merged = [...skills]
    pasted.forEach((skill) => {
      if (!merged.some((s) => s.toLowerCase() === skill.toLowerCase())) {
        merged.push(skill)
      }
    })
    onChange(merged)
    setInputValue('')
  }

  return (
    <div
      className={`min-h-[46px] w-full rounded-xl border border-slate-200 bg-white px-3 py-2 transition-all duration-200 focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-500/20 ${
        disabled ? 'opacity-60 pointer-events-none' : ''
      }`}
      onClick={() => inputRef.current?.focus()}
    >
      <div className="flex flex-wrap items-center gap-2">
        {skills.map((skill, index) => (
          <span
            key={`${skill}-${index}`}
            className="inline-flex items-center gap-1.5 rounded-lg border border-primary-100 bg-gradient-to-r from-primary-50 to-sky-50 px-2.5 py-1 text-xs font-medium text-primary-700 animate-tag-pop"
          >
            {skill}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                removeSkill(index)
              }}
              className="flex h-4 w-4 items-center justify-center rounded-full text-primary-500 transition-colors hover:bg-primary-100 hover:text-primary-700"
              aria-label={`Remove ${skill}`}
            >
              <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>
        ))}
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onBlur={() => addSkill(inputValue)}
          disabled={disabled}
          placeholder={skills.length === 0 ? 'Type a skill and press Enter' : 'Add another skill...'}
          className="min-w-[140px] flex-1 border-0 bg-transparent py-1 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-0"
        />
      </div>
    </div>
  )
}

export default SkillsTagInput
